import butterfieldLogoUrl from "./BR-Wordmark-Primary-Black-RGB.svg?inline";

export const butterfieldLogo = butterfieldLogoUrl;

